<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-if="item">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">供应商名称</label>
            <span class="weui-form-preview__value">{{item.vy_vend_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{item.vy_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年应付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_year_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">当前应付余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_end}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年已付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_paid}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年未付金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_add_pay_remain_nb}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年入库金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_add_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年预付余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本年已核金额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_reduce_pay}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">年初应付余额</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.vy_begin_pay}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <router-link
        :to="{name: 'PurchaseApcheckByMonth', params: {item}}"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >对账明细表</router-link>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if(!to.params.item)to.params.item = from.params.item || null // 兼容返回到本页
    next();
  },
  data() {
    var item = this.$route.params.item
    return {
      item
    };
  },
  computed: {
    vy_endamount() {
      return this.item.vy_nowamount - this.item.vy_nowprepayamount - this.item.vy_nowpayamount
    }
  }
}
</script>